import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App'
// Meta Pixel
;
(function () {
  const f = window as any;
  if (f.fbq) return;
  const n: any = f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!f._fbq) f._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  const t = document.createElement('script');
  t.async = true;
  t.src = 'https://connect.facebook.net/en_US/fbevents.js';
  const s = document.getElementsByTagName('script')[0];
  s.parentNode?.insertBefore(t, s);
  f.fbq('init', '631216272815399');
  f.fbq('track', 'PageView');
})();
render(<App data-id="element-237" />, document.getElementById('root'));